<template>
  <div>
    <vxe-grid
      ref="table"
      highlight-hover-row
      :columns="tableColumns"
      :data="tableData"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      size="small"
      resizable
      border
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.importTemplateStatus === '已启用' ? 'light' : 'warning'"
        >
          {{ row.importTemplateStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="下载" placement="top">
            <i
              class="el-icon-download tool-btn"
              @click="download(row.importTemplateFileUrl)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import dayjs from '@/libs/util.date'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      tableColumns: tableColumns()
    }
  },
  methods: {
    async download(importTemplateFileUrl) {
      if (!importTemplateFileUrl) {
        this.$message({
          showClose: true,
          message: '该文件无下载路径',
          type: 'warning'
        })
      }
      this.$api.exportBlobFile(
        importTemplateFileUrl,
        `车辆管理信息模板${dayjs().format('YYYYMMDDHHmmss')}`,
        { method: 'get' }
      )
    }
  }
}
</script>
